"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2699],{

/***/ 93736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hP": function() { return /* binding */ getAccessToken; },
/* harmony export */   "tW": function() { return /* binding */ handleAuthenticationError; }
/* harmony export */ });
/* unused harmony exports getPartner, logout */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_AccessTokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34434);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);



var getAccessToken = function(accessTokenType) {
    var item = window.sessionStorage.getItem(accessTokenType);
    if (item) return JSON.parse(item);
};
var getPartner = function() {
    var item = window.sessionStorage.getItem("partner");
    if (item) return JSON.parse(item);
};
var handleAuthenticationError = function(app) {
    Object.keys(_models_AccessTokens__WEBPACK_IMPORTED_MODULE_1__/* .AccessTokenType */ .T).forEach(function(type) {
        return sessionStorage.removeItem(type);
    });
    if (app === "DevPortal") {
        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("keycloak", {
            callbackUrl: "/portal/callback"
        });
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/internal/login");
    }
};
var logout = function() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Internal";
    Object.keys(_models_AccessTokens__WEBPACK_IMPORTED_MODULE_1__/* .AccessTokenType */ .T).forEach(function(type) {
        return sessionStorage.removeItem(type);
    });
    if (app === "DevPortal") {
        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signOut)({
            callbackUrl: "/"
        });
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/internal/signedout");
    }
};
var Auth = {
    getAccessToken: getAccessToken,
    getPartner: getPartner,
    logout: logout
};
/* harmony default export */ __webpack_exports__["ZP"] = (Auth);


/***/ }),

/***/ 15374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": function() { return /* binding */ padSlash; },
/* harmony export */   "PM": function() { return /* binding */ Headers; },
/* harmony export */   "SV": function() { return /* binding */ getBaseUrl; },
/* harmony export */   "bT": function() { return /* binding */ ContentTypes; },
/* harmony export */   "fq": function() { return /* binding */ Methods; },
/* harmony export */   "kG": function() { return /* binding */ getApiUrl; },
/* harmony export */   "lK": function() { return /* binding */ getBearerTokenAuthenticationHeader; },
/* harmony export */   "nd": function() { return /* binding */ ResponseStatuses; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var models_Environments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18724);


var Headers = {
    Accept: "Accept",
    Authorization: "Authorization",
    ContentType: "Content-Type",
    AppId: "App-Identity"
};
var Methods = {
    Get: "GET",
    Post: "POST",
    Patch: "PATCH",
    Delete: "DELETE",
    Put: "PUT"
};
var ResponseStatuses = {
    Unauthorized: 401,
    BadRequest: 400
};
var ContentTypes = {
    ApplicationJson: "application/json"
};
var getBearerTokenAuthenticationHeader = function(accessToken) {
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, Headers.Authorization, "Bearer ".concat(accessToken));
};
var getBaseUrl = function() {
    var env = (0,models_Environments__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentOrDefault */ .Rh)();
    if (env) {
        var ref;
        (0,models_Environments__WEBPACK_IMPORTED_MODULE_0__/* .setCurrent */ .c)(env);
        var url = (ref = models_Environments__WEBPACK_IMPORTED_MODULE_0__/* .UrlByEnvironment.find */ .es.find(function(config) {
            return config.value === env;
        })) === null || ref === void 0 ? void 0 : ref.url;
        if (!url) {
            throw new Error("Invalid environment setting! Please clear local storage!");
        }
        return url;
    }
    throw new Error("Missing environment setting!");
};
var getApiUrl = function(endpoint, pathParams, queryParams) {
    var path;
    if (pathParams) {
        path = endpoint.withPathParams(pathParams).toString();
    } else {
        path = endpoint.toString();
    }
    var url = new URL(path, getBaseUrl());
    if (queryParams) {
        Object.keys(queryParams).forEach(function(name) {
            return url.searchParams.append(name, queryParams[name].toString());
        });
    }
    return url;
};
var padSlash = function(str) {
    if (!str.startsWith("/")) return "/".concat(str);
    return str;
};


/***/ }),

/***/ 22699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ useActiveTrack; },
/* harmony export */   "E2": function() { return /* binding */ usePageMode; },
/* harmony export */   "H9": function() { return /* binding */ useMenu; },
/* harmony export */   "IW": function() { return /* binding */ smallScreenWidth; },
/* harmony export */   "Jq": function() { return /* binding */ useInternalAuthentication; },
/* harmony export */   "KK": function() { return /* binding */ useFocus; },
/* harmony export */   "Kg": function() { return /* binding */ useCheckMobileScreen; },
/* harmony export */   "NS": function() { return /* binding */ useContentfulPreview; },
/* harmony export */   "O7": function() { return /* binding */ useEnvironment; },
/* harmony export */   "Ww": function() { return /* binding */ usePlayerQueue; },
/* harmony export */   "ei": function() { return /* binding */ useInternal; },
/* harmony export */   "km": function() { return /* binding */ useTabMenu; },
/* harmony export */   "r$": function() { return /* binding */ useLoading; },
/* harmony export */   "tr": function() { return /* binding */ useLanding; },
/* harmony export */   "tv": function() { return /* binding */ useRouter; },
/* harmony export */   "vI": function() { return /* binding */ usePortal; },
/* harmony export */   "y_": function() { return /* binding */ useMessages; }
/* harmony export */ });
/* unused harmony exports useLocalStorage, useSessionStorage, useAnchor */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15374);
/* harmony import */ var providers_activetrackprovider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59451);
/* harmony import */ var providers_authenticationprovider_internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48716);
/* harmony import */ var providers_contentfulpreviewprovider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57642);
/* harmony import */ var providers_environmentprovider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41319);
/* harmony import */ var providers_loadingprovider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79342);
/* harmony import */ var providers_messageprovider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17581);
/* harmony import */ var providers_pagemodeprovider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69329);
/* harmony import */ var providers_playerqueueprovider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43165);














var useLocalStorage = function(key, initialValue) {
    return storageHooks(key, window.localStorage, initialValue);
};
var useSessionStorage = function(key, initialValue) {
    return storageHooks(key, window.sessionStorage, initialValue);
};
var useMessages = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_messageprovider__WEBPACK_IMPORTED_MODULE_8__/* .MessageContext */ .E);
    if (!context) throw Error("No message context defined!");
    var message = context.message, addError = context.addError, addInfo = context.addInfo, addSuccess = context.addSuccess, removeMessage = context.removeMessage;
    return {
        message: message,
        addError: addError,
        addInfo: addInfo,
        addSuccess: addSuccess,
        removeMessage: removeMessage
    };
};
var useLoading = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_loadingprovider__WEBPACK_IMPORTED_MODULE_7__/* .LoadingContext */ .p);
    if (!context) throw Error("No loading context defined!");
    var isLoading = context.isLoading, setLoading = context.setLoading;
    return {
        isLoading: isLoading,
        setLoading: setLoading
    };
};
var useInternalAuthentication = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_authenticationprovider_internal__WEBPACK_IMPORTED_MODULE_4__/* .InternalAuthenticationContext */ .e);
    if (!context) throw Error("No authentication context defined!");
    var accessToken = context.accessToken, isAuthenticated = context.isAuthenticated, logout = context.logout;
    return {
        accessToken: accessToken,
        isAuthenticated: isAuthenticated,
        logout: logout
    };
};
var usePageMode = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_pagemodeprovider__WEBPACK_IMPORTED_MODULE_9__/* .PageModeContext */ .d);
    if (!context) throw Error("No page mode context defined!");
    var pageMode = context.pageMode, collectionState = context.collectionState, setPageMode = context.setPageMode, saveCollectionState = context.saveCollectionState, resetCollectionState = context.resetCollectionState;
    return {
        pageMode: pageMode,
        collectionState: collectionState,
        setPageMode: setPageMode,
        saveCollectionState: saveCollectionState,
        resetCollectionState: resetCollectionState
    };
};
var useActiveTrack = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_activetrackprovider__WEBPACK_IMPORTED_MODULE_3__/* .ActiveTrackContext */ .O);
    if (!context) throw Error("No active track context defined!");
    var status = context.status, setStatus = context.setStatus, activeTrack = context.activeTrack, playTrack = context.playTrack, pauseTrack = context.pauseTrack, stopTrack = context.stopTrack, startFromHighlights = context.startFromHighlights, setStartFromHighlights = context.setStartFromHighlights;
    return {
        status: status,
        setStatus: setStatus,
        activeTrack: activeTrack,
        playTrack: playTrack,
        pauseTrack: pauseTrack,
        stopTrack: stopTrack,
        startFromHighlights: startFromHighlights,
        setStartFromHighlights: setStartFromHighlights
    };
};
var useEnvironment = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_environmentprovider__WEBPACK_IMPORTED_MODULE_6__/* .EnvironmentContext */ .g);
    if (!context) throw Error("No environment context defined!");
    var environment = context.environment, activeEnvironments = context.activeEnvironments, activateEnvironment = context.activateEnvironment;
    return {
        environment: environment,
        activeEnvironments: activeEnvironments,
        activateEnvironment: activateEnvironment
    };
};
var useContentfulPreview = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_contentfulpreviewprovider__WEBPACK_IMPORTED_MODULE_5__/* .ContentfulPreviewContext */ .E);
    if (!context) throw Error("No contentful preview defined!");
    var isPreview = context.isPreview, setPreview = context.setPreview;
    return {
        isPreview: isPreview,
        setPreview: setPreview
    };
};
var usePlayerQueue = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_playerqueueprovider__WEBPACK_IMPORTED_MODULE_10__/* .PlayerQueueContext */ .M);
    if (!context) throw Error("No player queue context defined!");
    var queue = context.queue, nextTrack = context.nextTrack, setQueue = context.setQueue;
    return {
        queue: queue,
        nextTrack: nextTrack,
        setQueue: setQueue
    };
};
var smallScreenWidth = 768;
var useCheckMobileScreen = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(smallScreenWidth), width = ref[0], setWidth = ref[1];
    var handleWindowSizeChange = function() {
        setWidth(window.innerWidth);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("resize", handleWindowSizeChange);
        return function() {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    return [
        width < smallScreenWidth
    ];
};
var storageHooks = function(key, storage, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = useState(function() {
        try {
            // Get from local storage by key
            var item = storage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to sessionStorage.
    var setValue = function(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = _instanceof(value, Function) ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            if (value) {
                storage.setItem(key, JSON.stringify(valueToStore));
            } else {
                storage.removeItem(key);
            }
        } catch (error) {
            return;
        }
    };
    return [
        storedValue,
        setValue
    ];
};
var useTabMenu = function() {
    var defaultSelectedTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultSelectedTab), selectedTab = ref[0], setSelectedTab = ref[1];
    var handleMenuNav = function(selectedTabIndex) {
        setSelectedTab(selectedTabIndex);
    };
    var handleMenuNavCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(selectedTabIndex) {
        return handleMenuNav(selectedTabIndex);
    }, []);
    return [
        selectedTab,
        handleMenuNavCallback
    ];
};
var useFocus = function() {
    var htmlElRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var setFocus = function() {
        var currentEl = htmlElRef.current;
        currentEl && currentEl.focus();
    };
    return [
        htmlElRef,
        setFocus
    ];
};
var useRouter = function(app) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    switch(app){
        case "DevPortal":
            return usePortal();
        case "Internal":
            return useInternal();
        default:
            return useLanding();
    }
};
var useInternal = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var pushInternal = function(url, as) {
        if (as) {
            router.push("/internal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)), "/internal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(as)));
        } else {
            router.push("/internal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)));
        }
    };
    return [
        pushInternal,
        router
    ];
};
var usePortal = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var pushPortal = function(url, as) {
        if (as) {
            router.push("/portal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)), "/portal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(as)));
        } else {
            router.push("/portal".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)));
        }
    };
    return [
        pushPortal,
        router
    ];
};
var useLanding = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var pushLanding = function(url, as) {
        if (as) {
            router.push("".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)), "".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(as)));
        } else {
            router.push("".concat((0,_api_utils__WEBPACK_IMPORTED_MODULE_2__/* .padSlash */ .$g)(url)));
        }
    };
    return [
        pushLanding,
        router
    ];
};
var useMenu = function(tabs) {
    var app = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Internal";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(useRouter(app), 2), push = ref[0], router = ref[1];
    var findActiveTabIndex = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(pathname) {
        return tabs.findIndex(function(param) {
            var url = param.url, match = param.match;
            return match ? match.test(pathname) : url === pathname;
        });
    }, [
        tabs
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return setSelectedTab(findActiveTabIndex(router.pathname));
    }, [
        router.pathname,
        findActiveTabIndex
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(findActiveTabIndex(router.pathname)), selectedTab = ref1[0], setSelectedTab = ref1[1];
    var handleMenuNav = function(idx) {
        var selectedTab = tabs[idx];
        if (selectedTab.url) {
            push(selectedTab.url);
        } else if (selectedTab.onClick) {
            selectedTab.onClick();
        }
    };
    return [
        selectedTab,
        handleMenuNav
    ];
};
var useAnchor = function() {
    var ref = useState(), hash = ref[0], setHash = ref[1];
    useEffect(function() {
        if (hash) {
            var timeout = setTimeout(function() {
                try {
                    var anchorElement = document.querySelector(toAnchor(hash));
                    strollToElement(anchorElement);
                } catch (e) {
                // Invalid hash value!
                }
            }, 500);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        hash
    ]);
    return [
        setHash
    ];
};
var Hooks = {
    useMessages: useMessages
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Hooks)));


/***/ }),

/***/ 34434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ AccessToken; },
/* harmony export */   "T": function() { return /* binding */ AccessTokenType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var AccessTokenType = {
    JWT: "JWT"
};
var AccessToken = function AccessToken(type, value) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, AccessToken);
    this.type = type;
    this.value = value;
};


/***/ }),

/***/ 18724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rh": function() { return /* binding */ getCurrentOrDefault; },
/* harmony export */   "TE": function() { return /* binding */ getCurrent; },
/* harmony export */   "c": function() { return /* binding */ setCurrent; },
/* harmony export */   "dK": function() { return /* binding */ DEFAULT_API_BASE_URl; },
/* harmony export */   "es": function() { return /* binding */ UrlByEnvironment; },
/* harmony export */   "x": function() { return /* binding */ isCypress; }
/* harmony export */ });
/* unused harmony exports Environment, getActiveEnvironments */
/* provided dependency */ var process = __webpack_require__(83454);
var Environment = "environment";
var DEFAULT_API_BASE_URl = "https://partner-content-api.epidemicsound.com";
var UrlByEnvironment = [
    {
        value: "Local",
        url: process.env.NEXT_PUBLIC_LOCAL_API_BASE_URL
    },
    {
        value: "Dev",
        url: process.env.NEXT_PUBLIC_DEV_API_BASE_URL
    },
    {
        value: "Staging",
        url: process.env.NEXT_PUBLIC_STAGING_API_BASE_URL
    },
    {
        value: "Production",
        url: "https://partner-content-api.epidemicsound.com"
    }, 
];
var getActiveEnvironments = function() {
    var environments = [];
    var appEnvironment = "Production";
    switch(appEnvironment){
        case "Local":
            if (process.env.NEXT_PUBLIC_LOCAL_API_BASE_URL) environments.push("Local");
            break;
        case "Dev":
            if (process.env.NEXT_PUBLIC_DEV_API_BASE_URL) environments.push("Dev");
            break;
        case "Staging":
            if (process.env.NEXT_PUBLIC_STAGING_API_BASE_URL) environments.push("Staging");
            break;
        case "Production":
            if (true) environments.push("Production");
            break;
    }
    return environments;
};
var activeEnvironments = getActiveEnvironments();
var getCurrent = function() {
    var env = window.localStorage.getItem(Environment);
    if (env) {
        return JSON.parse(env);
    }
};
var getCurrentOrDefault = function() {
    var env = getCurrent();
    if (!env) {
        env = "Production";
        if (!env) {
            env = activeEnvironments[0];
        }
    }
    return env;
};
var setCurrent = function(environment) {
    window.localStorage.setItem(Environment, JSON.stringify(environment));
};
var isCypress = function() {
    return  true && sessionStorage.getItem("CYPRESS_ENVIRONMENT") === "true";
};
var Environments = {
    getCurrent: getCurrent,
    activeEnvironments: activeEnvironments,
    setCurrent: setCurrent,
    getCurrentOrDefault: getCurrentOrDefault
};
/* harmony default export */ __webpack_exports__["ZP"] = (Environments);


/***/ }),

/***/ 59451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ActiveTrackContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ActiveTrackContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var ActiveTrackProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), activeTrack = ref[0], setActiveTrack = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("pause"), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), startFromHighlights = ref2[0], setStartFromHighlights = ref2[1];
    var playTrack = function(track) {
        setActiveTrack(track);
        setStatus("play");
    };
    var stopTrack = function() {
        setActiveTrack(undefined);
        setStatus("pause");
    };
    var pauseTrack = function() {
        setStatus("pause");
    };
    var togglePlayHighlights = function() {
        setStartFromHighlights(function(prev) {
            return !prev;
        });
    };
    var contextValue = {
        status: status,
        activeTrack: activeTrack,
        setStatus: setStatus,
        playTrack: playTrack,
        stopTrack: stopTrack,
        pauseTrack: pauseTrack,
        togglePlayHighlights: togglePlayHighlights,
        startFromHighlights: startFromHighlights,
        setStartFromHighlights: setStartFromHighlights
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActiveTrackContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActiveTrackProvider);


/***/ }),

/***/ 48716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ InternalAuthenticationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var models_AccessTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34434);
/* harmony import */ var api_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93736);
/* harmony import */ var hooks_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22699);
/* harmony import */ var _okta_okta_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38937);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);







var InternalAuthenticationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var AuthenticationProvider = function(param) {
    var children = param.children, accessTokenType = param.accessTokenType;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), accessToken = ref[0], setAccessToken = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAuthenticated = ref1[0], setAuthenticatated = ref1[1];
    var addError = (0,hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useMessages */ .y_)().addError;
    var oktaAuth = (0,_okta_okta_react__WEBPACK_IMPORTED_MODULE_5__/* .useOktaAuth */ .JN)().oktaAuth;
    var logout = function() {
        setAccessToken(undefined);
        api_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].logout */ .ZP.logout();
    };
    var contextValue = {
        isAuthenticated: isAuthenticated,
        accessToken: accessToken,
        logout: logout
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var persistedAccessToken = api_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAccessToken */ .ZP.getAccessToken(accessTokenType);
        if (!accessToken && persistedAccessToken || accessToken && !persistedAccessToken) {
            setAccessToken(persistedAccessToken);
        }
        setAuthenticatated(accessToken !== undefined);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var interval = setInterval(function() {
            try {
                oktaAuth.authStateManager.updateAuthState().then(function(authState) {
                    if (authState.isAuthenticated) {
                        oktaAuth.tokenManager.renew("accessToken").then(function() {
                            var oktaToken = oktaAuth.getAccessToken();
                            if (oktaToken) {
                                var accessToken = new models_AccessTokens__WEBPACK_IMPORTED_MODULE_2__/* .AccessToken */ .J(models_AccessTokens__WEBPACK_IMPORTED_MODULE_2__/* .AccessTokenType.JWT */ .T.JWT, oktaToken);
                                window.sessionStorage.setItem(models_AccessTokens__WEBPACK_IMPORTED_MODULE_2__/* .AccessTokenType.JWT */ .T.JWT, JSON.stringify(accessToken));
                                setAccessToken(accessToken);
                            }
                        }).catch(function() {
                            addError(utils__WEBPACK_IMPORTED_MODULE_6__/* .GENERAL_ERROR */ .PC);
                        });
                    }
                }).catch(function() {
                    addError(utils__WEBPACK_IMPORTED_MODULE_6__/* .GENERAL_ERROR */ .PC);
                });
            } catch (e) {
                addError(utils__WEBPACK_IMPORTED_MODULE_6__/* .GENERAL_ERROR */ .PC);
            }
        }, 1800000);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InternalAuthenticationContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthenticationProvider);


/***/ }),

/***/ 57642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ContentfulPreviewContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ContentfulPreviewContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var ContentfulPreviewProvider = function(param) {
    var initialPreview = param.initialPreview, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialPreview), isPreview = ref[0], setPreview = ref[1];
    var contextValue = {
        isPreview: isPreview,
        setPreview: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(isPreview) {
            setPreview(isPreview);
        }, [])
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulPreviewContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentfulPreviewProvider);


/***/ }),

/***/ 41319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EnvironmentContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var models_Environments__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18724);



var EnvironmentContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var EnvironmentProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), environment = ref[0], setEnvironment = ref[1];
    var activateEnvironment = function(environment) {
        models_Environments__WEBPACK_IMPORTED_MODULE_2__/* ["default"].setCurrent */ .ZP.setCurrent(environment);
        setEnvironment(environment);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!environment) {
            setEnvironment(models_Environments__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCurrentOrDefault */ .ZP.getCurrentOrDefault());
        }
    });
    var contextValue = {
        environment: environment,
        activeEnvironments: models_Environments__WEBPACK_IMPORTED_MODULE_2__/* ["default"].activeEnvironments */ .ZP.activeEnvironments,
        activateEnvironment: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(environment) {
            return activateEnvironment(environment);
        }, [])
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EnvironmentContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EnvironmentProvider);


/***/ }),

/***/ 79342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ LoadingContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoadingContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var LoadingProvider = function(param) {
    var initialLoading = param.initialLoading, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialLoading), isLoading = ref[0], setLoading = ref[1];
    var contextValue = {
        isLoading: isLoading,
        setLoading: setLoading
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadingContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingProvider);


/***/ }),

/***/ 17581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MessageContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65119);



var NotificationType = _epidemicsound_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Notification.TYPES */ .P.TYPES;
var MessageContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var MessageProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), message = ref[0], setMessage = ref[1];
    var removeMessage = function() {
        return setMessage(null);
    };
    var addError = function(errors) {
        return setMessage({
            messages: errors,
            type: NotificationType.ERROR
        });
    };
    var addInfo = function(infos) {
        return setMessage({
            messages: infos,
            type: NotificationType.INFO
        });
    };
    var addSuccess = function(success) {
        return setMessage({
            messages: success,
            type: NotificationType.SUCCESS
        });
    };
    var contextValue = {
        message: message,
        addError: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
            for(var _len = arguments.length, errors = new Array(_len), _key = 0; _key < _len; _key++){
                errors[_key] = arguments[_key];
            }
            return addError(errors);
        }, []),
        addInfo: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
            for(var _len = arguments.length, infos = new Array(_len), _key = 0; _key < _len; _key++){
                infos[_key] = arguments[_key];
            }
            return addInfo(infos);
        }, []),
        addSuccess: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
            for(var _len = arguments.length, successfull = new Array(_len), _key = 0; _key < _len; _key++){
                successfull[_key] = arguments[_key];
            }
            return addSuccess(successfull);
        }, []),
        removeMessage: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
            return removeMessage();
        }, [])
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MessageContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MessageProvider);


/***/ }),

/***/ 69329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PageModeContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PageModeContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var PageModeProvider = function(param) {
    var initialMode = param.initialMode, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialMode), pageMode = ref[0], setPageMode = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), collectionState = ref1[0], setCollectionState = ref1[1];
    var saveCollectionState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(collectionState) {
        setCollectionState(collectionState);
    }, []);
    var resetCollectionState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setCollectionState(undefined);
    }, []);
    var contextValue = {
        pageMode: pageMode,
        collectionState: collectionState,
        saveCollectionState: saveCollectionState,
        setPageMode: setPageMode,
        resetCollectionState: resetCollectionState
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageModeContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageModeProvider);


/***/ }),

/***/ 43165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PlayerQueueContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var hooks_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22699);






var PlayerQueueContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
var PlayerQueueProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), queue = ref[0], setQueue = ref[1];
    var ref1 = (0,hooks_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useActiveTrack */ .AP)(), playTrack = ref1.playTrack, activeTrack = ref1.activeTrack;
    var nextTrack = function(track) {
        if (queue) {
            if (activeTrack && activeTrack.id === (track === null || track === void 0 ? void 0 : track.id)) {
                // This is the current track that was paused .
                // So we will just unpause.
                playTrack((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, track), {
                    queueName: queue.name
                }));
            } else if (track) {
                // Find the requested track!
                var trackIndex = queue.tracks.findIndex(function(t) {
                    return t.id === track.id;
                });
                if (trackIndex !== -1) {
                    // Rebuild queue from that track!
                    var leftSide = queue.tracks.slice(0, trackIndex);
                    var rightSide = queue.tracks.slice(trackIndex + 1, queue.tracks.length);
                    var nextTrack = queue.tracks[trackIndex];
                    playTrack((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, nextTrack), {
                        queueName: queue.name
                    }));
                    setQueue({
                        name: queue.name,
                        tracks: rightSide.concat(leftSide).concat([
                            nextTrack
                        ])
                    });
                }
            } else {
                var tracks = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(queue.tracks);
                // No track given. Just play the next in queue!
                var nextActiveTrack = tracks.shift();
                if (nextActiveTrack) {
                    if (activeTrack && activeTrack.id === nextActiveTrack.id) {
                        // The active track is the same as the current.
                        // Skip one more and put last.
                        tracks.push(nextActiveTrack);
                        nextActiveTrack = tracks.shift();
                    }
                    if (nextActiveTrack) {
                        playTrack((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, nextActiveTrack), {
                            queueName: queue.name
                        }));
                        // Put last!
                        setQueue({
                            name: queue.name,
                            tracks: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tracks).concat([
                                nextActiveTrack
                            ])
                        });
                    }
                }
            }
        }
    };
    var contextValue = {
        queue: queue,
        nextTrack: nextTrack,
        setQueue: (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(queue) {
            return setQueue(queue);
        }, [])
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlayerQueueContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayerQueueProvider);


/***/ }),

/***/ 59830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GL": function() { return /* binding */ API_FORM_REQUEST_URL; },
/* harmony export */   "PC": function() { return /* binding */ GENERAL_ERROR; },
/* harmony export */   "zb": function() { return /* binding */ INACTIVE_COLLECTION_DEFAULT_SORT; }
/* harmony export */ });
var INACTIVE_COLLECTION_DEFAULT_SORT = 1000;
var GENERAL_ERROR = "An error ocurred!";
var API_FORM_REQUEST_URL = "https://docs.google.com/forms/d/1oz7VqvQHmDCEqQX41uEN55NuI8ciou77nIfxpp7Z-7I/edit?urlBuilderDomain=epidemicsound.com&gxids=7628";


/***/ })

}]);